import * as React from "react";
import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";
import { PaymentState } from "@nju/data-access-portal-payment";
import { IScope } from "@nju/scope";
import { BlockText, Modal, Separator, Text, useOverlay } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { PaymentStatus } from "./PaymentStatus";
import { SwitchFtthPaymentModal } from "./SwitchFtthPaymentModal";

interface ISidebarMobilePaymentDetailsProps {
  orderSummary: IMobileOrchestrator["orderSummary"] | undefined;
  paymentState: PaymentState | undefined;
  state: IMobileOrchestrator["state"] | "REACTIVATION" | undefined;
  isPending: boolean;
  variant: IScope;
  userId: string | undefined;
}

export function SidebarMobilePaymentDetails({
  paymentState,
  state,
  isPending,
  orderSummary,
  variant,
  userId,
}: ISidebarMobilePaymentDetailsProps) {
  const modal = useOverlay();
  const showChangePaymentButton =
    (state && ["REACTIVATION"].includes(state)) || false;

  const openModal = React.useCallback(() => {
    modal.open();
  }, [modal]);

  if (orderSummary === undefined) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <>
      <Separator tone="invisible" />
      {!!(orderSummary && orderSummary.totalOrderDiscount) && (
        <div
          className="grid gap-2 grid-cols-[2fr_1fr] items-center"
          data-cy="month-discount"
        >
          <Text>rabat miesięczny:</Text>
          <Text align="right" testId="discount">
            -{formatPrice(orderSummary.totalOrderDiscount)} zł
          </Text>
        </div>
      )}
      <div
        className="flex gap-2 justify-between items-center"
        data-cy="recurring-price"
      >
        <Text>opłata miesięczna:</Text>
        <Text align="right" size="xl" testId="box-payment-price" weight="bold">
          {formatPrice(orderSummary.totalRecurringOrderPrice)} zł
        </Text>
      </div>
      <Separator size="xs" thickness="medium" />
      {paymentState && (
        <>
          <Separator size="xs" tone="invisible" />
          <PaymentStatus
            isPending={isPending}
            openModal={openModal}
            paymentState={paymentState}
            showChangePaymentButton={showChangePaymentButton}
            userId={userId}
            variant={variant}
          />
        </>
      )}
      {state === "REACTIVATION" && (
        <>
          <Separator size="xs" thickness="medium" />
          <BlockText size="s">
            Usługa zostanie włączona po potwierdzeniu płatności.
          </BlockText>
        </>
      )}
      {modal.isOpened && (
        <Modal onClose={modal.close}>
          <SwitchFtthPaymentModal
            closeModal={() => {
              return modal.close();
            }}
          />
        </Modal>
      )}
    </>
  );
}
